import { useState, useEffect} from "react";
import { getStoryblokApi } from "@storyblok/react";

// https://www.storyblok.com/docs/api/content-delivery/v2#core-resources/links/retrieve-multiple-links
function useStoryblokLinkMap() {
  const [linkObject,setLinkObject] = useState({});

  useEffect(()=>{
    getStoryblokLinks()
      .then((data)=>{
        setLinkObject(data);
      })
      .catch((err)=>{
        console.error(err);
      });
  }, []);

  return linkObject;
}

function useStoryblokLink(story_uuid) {
  const [linkStory,setLinkStory] = useState({})
  
  useEffect(()=>{
    if(story_uuid) {
      getCachedLink(story_uuid).then((story)=>{
        setLinkStory(story)
      }).catch((err)=>{
        console.error(err)
      })
    }
  },[story_uuid])

  return linkStory
}

function getStoryblokLinks() {
  return new Promise((resolve,reject)=>{
    const storyblokApi = getStoryblokApi()
    storyblokApi.get("cdn/links", { 
      version: process.env.STORYBLOK_API_CONTENT_VERSION,
    }).then(({ data })=>{
      if(data && data.links) {
        resolve(data.links)
      }
    }).catch(reject)
  })
}

function getCachedLink(story_uuid) {
  return new Promise((resolve,reject)=>{
    if(!window.storyblok_link_cache) {
      window.storyblok_link_cache = getStoryblokLinks()
        .then((links)=>{
          window.storyblok_link_cache = links
          return links
        })
    }

    if(typeof window.storyblok_link_cache === "object" && typeof window.storyblok_link_cache.then === "function") {
      window.storyblok_link_cache.then((links)=>{
        resolve(links[story_uuid])
      })
    } else {
      resolve(window.storyblok_link_cache[story_uuid])
    }
  })
}
function getCachedLinks() {
  return new Promise((resolve,reject)=>{
    if(!window.storyblok_link_cache) {
      window.storyblok_link_cache = getStoryblokLinks()
        .then((links)=>{
          window.storyblok_link_cache = links
          return links
        })
    }

    if(typeof window.storyblok_link_cache === "object" && typeof window.storyblok_link_cache.then === "function") {
      window.storyblok_link_cache.then((links)=>{
        resolve(links)
      })
    } else {
      resolve(window.storyblok_link_cache)
    }
  })

}
function getCachedLinksIDMap() {
  return new Promise((resolve,reject)=>{
    getCachedLinks()
      .then((uuidMap)=>{
        let newMap = {}
        for(let uuid in uuidMap) {
          newMap[uuidMap[uuid].id] = uuidMap[uuid]
        }
        resolve(newMap)
      })
  })
}

export { useStoryblokLink, useStoryblokLinkMap, getStoryblokLinks, getCachedLinks, getCachedLinksIDMap }